import React, { useState } from 'react';

function App() {
  const [description, setDescription] = useState('');
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(false);

  const generateBrands = async () => {
    if (!description.trim()) return;
    setLoading(true);
    setBrands([]);
    try {
      const response = await fetch('http://localhost:5001/api/generate-brands', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ description })
      });
      const data = await response.json();
      if (data.success) setBrands(data.brands);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0f0a2e', color: '#fff', fontFamily: 'Nunito, sans-serif', padding: '40px 20px' }}>
      <div style={{ maxWidth: '700px', margin: '0 auto', textAlign: 'center' }}>

        <h1 style={{ fontSize: '48px', fontWeight: '900', marginBottom: '8px' }}>
          brand<span style={{ color: '#fde047' }}>ivo</span>
        </h1>
        <p style={{ color: '#a78bfa', letterSpacing: '3px', fontSize: '13px', marginBottom: '48px' }}>
          FROM EGG TO EMPIRE
        </p>

        <div style={{ background: '#1a1040', borderRadius: '16px', padding: '32px', marginBottom: '32px' }}>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Describe your business... (e.g. AI-powered brand registration platform)"
            style={{
              width: '100%', minHeight: '100px', background: '#0f0a2e',
              border: '1px solid #2a1f4a', borderRadius: '12px', padding: '16px',
              color: '#fff', fontSize: '16px', resize: 'vertical', outline: 'none',
              fontFamily: 'inherit', boxSizing: 'border-box'
            }}
          />
          <button
            onClick={generateBrands}
            disabled={loading}
            style={{
              marginTop: '16px', width: '100%', padding: '16px',
              background: loading ? '#4a3a8a' : '#7c3aed',
              border: 'none', borderRadius: '12px', color: '#fff',
              fontSize: '18px', fontWeight: '800', cursor: loading ? 'not-allowed' : 'pointer',
              fontFamily: 'inherit'
            }}
          >
            {loading ? '🔄 Checking domains...' : '🐣 Generate Brand Names'}
          </button>
        </div>

        {brands.length > 0 && (
          <div>
            {brands.map((brand, i) => (
              <div key={i} style={{
                background: '#1a1040', borderRadius: '12px', padding: '20px',
                marginBottom: '12px', textAlign: 'left',
                border: '1px solid #2a1f4a'
              }}>
                <div style={{ fontSize: '22px', fontWeight: '900', color: '#fde047', marginBottom: '4px' }}>
                  {brand.name}
                </div>
                <div style={{ color: '#a78bfa', marginBottom: '12px', fontSize: '14px' }}>
                  {brand.meaning}
                </div>

                {/* Domain badges */}
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  {Object.entries(brand.domains || {}).map(([ext, available]) => (
                    <span key={ext} style={{
                      padding: '4px 12px',
                      borderRadius: '20px',
                      fontSize: '13px',
                      fontWeight: '700',
                      background: available ? '#14532d' : '#3f1515',
                      color: available ? '#4ade80' : '#f87171',
                      border: `1px solid ${available ? '#166534' : '#7f1d1d'}`
                    }}>
                      {brand.name.toLowerCase()}{ext} {available ? '✅' : '❌'}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}

      </div>
    </div>
  );
}

export default App;